import type { Cinema } from "../types/entities/cinema"

export function cinemaDisplayName(cinema: Pick<Cinema, "name" | "full_name">): string {
    const raw = cinema.full_name ?? cinema.name ?? ""
    return (
        raw
            .replace(/^мягкий\s+кинотеатр\s+/i, "")
            .replace(/^[«""](.+)[»""]$/, "$1")
            .trim() || cinema.name
    )
}
